function normalizeLot(lot) {
  lot.lotNumberWithExtension = lot.lotNumber + (lot.lotNumberExtension || '');
  const bidIncrements = [];
  let bid = lot.currentBid;
  const MAX_INCREMENTS = 50;

  const idx = lot.bidIncrements.findIndex(({ min, max }) => bid >= min && bid <= max);

  if (idx !== -1) {
    for (let i = idx; i < lot.bidIncrements.length; i++) {
      if (bidIncrements.length === MAX_INCREMENTS) break;

      const { min, max, increment } = lot.bidIncrements[i];
      if (bid === max + 1 || bid === min) {
        bidIncrements.push(bid);
      }

      while ((bid) <= max && bidIncrements.length < MAX_INCREMENTS) {
        if (bidIncrements.at(-1) !== bid) bidIncrements.push(bid);
        bid += increment;
      }
    }
  }

  lot.bidIncrements = lot.bidCount ? bidIncrements.slice(1) : bidIncrements;
}

export function normalizeBidIncrements(lots) {
  const lotsCopy = JSON.parse(JSON.stringify(lots));
  lotsCopy.forEach(normalizeLot);
  return lotsCopy;
}

export function normalizeSuccessFailedBids(data, placedLotsData) {
  const successBids = [];
  const failedBids = [];
  return data.reduce((initialValue, bids) => {
    const { lotNumberWithExtension } = placedLotsData.find(({ lotRef }) => bids.lotRef === lotRef) || {};
    if (bids.success) initialValue.successBids.push(lotNumberWithExtension);
    else initialValue.failedBids.push(lotNumberWithExtension);
    return initialValue;
  }, { successBids, failedBids });
}
